import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { useTranslations } from '../../../../features/providers/translations-provider';
import Button from '../../../common/button';
import Div from '../../../common/div';
const ReviewNavigation = ({ handleSubmit, handleNext, handlePrev, isSubmit, isValid, submitLoading, }) => {
    const { t } = useTranslations();
    const theme = useTheme();
    const handlePrimary = async () => {
        if (isSubmit && !!handleSubmit) {
            handleSubmit();
        }
        else {
            handleNext();
        }
    };
    return (_jsxs(Div, { flex: 'row', justify: 'center', gap: 16, className: 'review-navigation', style: { marginTop: 8 }, children: [!!handlePrev && (_jsx(Button, { onClick: handlePrev, defaultStyle: theme.colors.white_1, withArrowLeft: true, children: t('navigation|previous') })), _jsx(Button, { onClick: (e) => {
                    e.preventDefault();
                    handlePrimary();
                }, defaultStyle: theme.colors.grey_1, withArrowRight: !isSubmit, loading: submitLoading, disabled: !isValid, children: isSubmit ? t('navigation|submit') : t('navigation|next') })] }));
};
export default ReviewNavigation;
